import { TAdministrativeLevel, TBackendAdministrativeLevel } from '@geovelo-frontends/commons';

export function getChildrenTypeKey(administrativeLevel: TAdministrativeLevel | null): string {
  if (!administrativeLevel) return 'commons.administrative_levels.zone';

  switch (administrativeLevel) {
    case 'world':
      return 'commons.administrative_levels.country';
    case 'country':
      return 'commons.administrative_levels.region';
    case 'region':
      return 'commons.administrative_levels.department';
    case 'department':
      return 'commons.administrative_levels.epci';
    case 'epci':
      return 'commons.administrative_levels.city';
    default:
      return 'commons.administrative_levels.zone';
  }
}

export function getChildrenBackendLevel(
  administrativeLevel: TAdministrativeLevel,
): TBackendAdministrativeLevel | null {
  switch (administrativeLevel) {
    case 'world':
      return 'COUNTRY';
    case 'country':
      return 'REGION';
    case 'region':
      return 'DEPARTMENT';
    case 'department':
      return 'EPCI';
    case 'epci':
      return 'CITY';
    default:
      return null;
  }
}
